import { render, staticRenderFns } from "./NewLeaderboard.vue?vue&type=template&id=3f94b850&"
import script from "./NewLeaderboard.vue?vue&type=script&lang=js&"
export * from "./NewLeaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports